import { FaCheck } from "react-icons/fa";
const Why = () => {
    
  return (
    <section className="section-padding">
      <div className="container">
        <div className="row flex-column flex-md-row align-items-md-center gap-3 gap-md-0">
          <div className="col-12 col-md-5">
            <h2>Mengapa Memilih Kami</h2>
            <p>Kursus Bahasa Inggris NIEC adalah tempat di mana tujuan belajar bahasa Inggris Anda berubah menjadi hasil nyata.</p>
            <p>Kami mengkhususkan diri dalam persiapan studi di luar negeri dan tes kemahiran bahasa Inggris — termasuk IELTS, TOEFL, dan Duolingo — dengan sistem terstruktur yang membantu Anda berkembang lebih cepat dan mencapai skor target dengan jelas.</p>
            <p>Dengan dukungan para tutor ahli dan lingkungan belajar yang berfokus pada program studi di luar negeri, Anda akan membangun kepercayaan diri, pola pikir, dan keterampilan yang dibutuhkan untuk meraih kesuksesan di kancah global.</p>
            {/* <ul>
              <li><FaCheck color="red" className="me-2"/>Mentor berpengalaman & supportive</li>
              <li><FaCheck color="red" className="me-2"/>Kelas fleksibel (Online & Offline)</li>
              <li><FaCheck color="red" className="me-2"/>Fokus ke hasil (Score & Confidence)</li>
              <li><FaCheck color="red" className="me-2"/>Personalized learning plan</li>
              <li><FaCheck color="red" className="me-2"/>Support sampai siap study abroad</li>
            </ul> */}
          </div>
          <div className="col-12 col-md-7">
            <div className="d-flex justify-content-center">        
              <div className="ratio ratio-16x9">
                <iframe 
                  src="https://www.youtube.com/embed/sLRzbS8R_Q0?autoplay=1&mute=1&loop=1&playlist=sLRzbS8R_Q0"
                  title="Langkah Awal Kuasai Bahasa Inggris untuk Masa Depan Global" 
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin" allowfullscreen
                ></iframe>              
              </div>
          </div>            
          </div>
        </div>      
      </div>
    </section>  
  );
}

export default Why;